import { render, staticRenderFns } from "./tipoAtendimento.vue?vue&type=template&id=2308c410"
import script from "./tipoAtendimento.vue?vue&type=script&lang=js"
export * from "./tipoAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports